(function () {
    let ths = document.querySelectorAll('th');
    let tds = document.querySelectorAll('td');

    for (const th of ths) {
        th.setAttribute('tabindex', '0')
    }
    for (const td of tds) {
        td.setAttribute('tabindex', '0')
    }
})();